// src/axiosConfig.js
import axios from "axios";
import { BASE_URL } from "../commom/UrlConstant";
import { hasLocalPushToken, releaseLocalPushToken } from "../services/pushLocalCleanup";

const Axios = axios.create({
  baseURL: BASE_URL,
});

Axios.interceptors.request.use(
  (config: any) => {
    //   debugger;
    const userString = localStorage.getItem("user");
    let user: any = null;

    if (userString) {
      user = JSON.parse(userString);
      config.headers.Authorization = `Bearer ${user.userToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response) => {
    //debugger;
    return response;
  },
  (error) => {
    //  debugger;
    // error.response is missing on network errors / timeouts: do not crash the handler on those.
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      // The session is gone, so the server-side unlink (which needs a valid login) cannot run. Delete this
      // browser's push token instead (no login needed) so it stops receiving the previous user's notifications.
      // The inactivity timeout that sends the user to /loginwithpin is NOT a logout and must not do this.
      const redirect = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("InvList");
        localStorage.removeItem("isAuthenticated"); // Optionally remove the user token
        localStorage.removeItem("onboardingStatusBar_dismissed");
        window.location.href = "/login"; // Redirect to the login page
      };
      if (hasLocalPushToken()) {
        // Wait briefly (max ~2.5 s) so the page does not unload before the token is deleted.
        void releaseLocalPushToken().finally(redirect);
      } else {
        redirect();
      }
    }
    return Promise.reject(error);
  }
);

export default Axios;
